import React, { useState } from 'react';
import { updatePassword } from '../services/passwordReset';
import { passwordStrength } from '../services/passwordStrength';
import PasswordStrength from '../components/PasswordStrength';

// Écran affiché après un clic sur le lien « mot de passe oublié » reçu par email.
const ResetPassword = ({ accessToken, onDone }) => {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!passwordStrength(password).valid) { setMessage('Ce mot de passe n\'est pas assez robuste : suivez les indications sous le champ.'); return; }
    if (password !== confirm) { setMessage('Les deux mots de passe ne sont pas identiques.'); return; }
    setLoading(true);
    setMessage('');
    try {
      await updatePassword(accessToken, password);
      onDone(true);
    } catch (err) {
      if (err.message === 'LINK_EXPIRED') onDone(false);
      else if (err.message === 'SAME_PASSWORD') setMessage('Choisissez un mot de passe différent de l\'ancien.');
      else if (err.message === 'WEAK_PASSWORD') setMessage('Ce mot de passe est trop simple. Choisissez-en un plus long ou plus varié.');
      else setMessage('Impossible d\'enregistrer le mot de passe pour le moment. Réessayez dans un instant.');
    }
    setLoading(false);
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logoWrap}>
          <img src="/favicon_nowatt.png" alt="" style={styles.logoImg} />
          <span style={styles.logo}><span style={styles.accent}>No</span>watt</span>
          <span style={styles.tagline}>Votre électricité au meilleur prix</span>
        </div>
        <h2 style={styles.title}>Nouveau mot de passe</h2>
        {message && <div style={styles.error}>{message}</div>}
        <form onSubmit={submit} style={styles.form}>
          <input style={styles.input} type="password" autoComplete="new-password" placeholder="Nouveau mot de passe" value={password} onChange={e => setPassword(e.target.value)} required />
          <PasswordStrength password={password} />
          <input style={styles.input} type="password" autoComplete="new-password" placeholder="Confirmez le mot de passe" value={confirm} onChange={e => setConfirm(e.target.value)} required />
          <button style={styles.btn} type="submit" disabled={loading}>
            {loading ? 'Chargement...' : 'Enregistrer'}
          </button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  container: { minHeight: '100vh', background: '#111620', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  card: { background: '#111620', border: '1px solid rgba(255,255,255,0.07)', borderRadius: 16, padding: '44px 40px', width: '100%', maxWidth: 400 },
  logoWrap: { textAlign: 'center', marginBottom: 32 },
  logoImg: { display: 'block', width: 64, height: 64, objectFit: 'contain', margin: '0 auto 10px' },
  logo: { fontFamily: "'Lexend', sans-serif", fontSize: '2rem', fontWeight: 700, color: '#EEF2FF' },
  accent: { color: '#C8F135' },
  tagline: { display: 'block', fontSize: '0.82rem', color: 'rgba(238,242,255,0.4)', marginTop: 6 },
  title: { fontFamily: "'Lexend', sans-serif", fontSize: '1.3rem', fontWeight: 600, color: '#EEF2FF', marginBottom: 24 },
  error: { background: 'rgba(200,241,53,0.1)', border: '1px solid rgba(200,241,53,0.3)', borderRadius: 8, padding: '10px 14px', fontSize: '0.82rem', color: '#C8F135', marginBottom: 16 },
  form: { display: 'flex', flexDirection: 'column', gap: 12 },
  input: { background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '12px 16px', color: '#EEF2FF', fontSize: '0.9rem', outline: 'none' },
  btn: { background: '#C8F135', color: '#06080C', border: 'none', borderRadius: 8, padding: '13px', fontWeight: 700, fontSize: '0.95rem', cursor: 'pointer', marginTop: 8 },
};

export default ResetPassword;
